<i18n src="@/locales/modules/DeviceInventoryTranslate.json"></i18n>

<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="setDialogHide => handleCloseDialog(setDialogHide, isFormDirty)"
		class="custom-nested-dialog"
		:title="$t(dataId ? 'UpdateInventoryItem' : 'CreateInventoryItem')"
		:visible.sync="isPopupActiveLocal"
	>
		<div class="p-6">
			<!-- NAME -->
			<div class="mb-5">
				<label for class="vs-input--label">{{ $t('InventoryItemName') }} <span class='text-danger'>*</span>:</label>
				<vs-input
					v-model="dataName"
					class="w-full"
					name="name"
					:data-vv-as="$t('InventoryItemName')"
					:placeholder="`${$t('Actions.Input')} ${$t('InventoryItemName')}`"
					v-validate="'required'"
				/>
				<span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
			</div>

			<!-- STREET -->
			<div class="my-5">
				<vs-input
					:label="`${$t('InventoryItemStreet')}:`"
					v-model="dataStreet"
					class="w-full"
					name="street"
					:placeholder="`${$t('Actions.Input')} ${$t('InventoryItemStreet')}`"
				/>
				<span class="text-danger text-sm" v-show="errors.has('street')">{{ errors.first('street') }}</span>
			</div>

			<!-- DESCRIPTION -->
			<div class="mt-5">
				<label for class="vs-input--label">{{ $t('InventoryItemDescription') }}:</label>
				<vs-textarea class="m-0" :placeholder="$t('InventoryItemDescription')" v-model="description" />
			</div>
		</div>

		<div class="flex justify-center" slot="footer">
			<vs-button
				class="w-full sm:w-1/3 font-bold"
				@click.stop="submitData"
			>{{ $t("Actions.Submit") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import _ from "lodash";

export default {
	props: {
		isPopupActive: {
			type: Boolean,
			required: true
		},
		data: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			dataId: null,
			dataName: "",
			dataStreet: "",
			description: "",

			initFormData: {},
			isFormDirty: false
		};
	},
	watch: {
		isPopupActive(val) {
			if (!val) return;

			const { id, name, street, description } = this.data;
			if (!this.data.id) {
				this.initValues();
			} else {
				this.dataId = id;
				this.dataName = name || "";
				this.dataStreet = street || "";
				this.description = description || "";
			}

			this.isFormDirty = false;
			this.initFormData = {
				dataId: this.dataId,
				dataName: this.dataName,
				dataStreet: this.dataStreet,
				description: this.description
			};
		},
		'computedFormData': {
			handler: function(newVal) {
				if(!this.isFormDirty && !_.isEqual(newVal, this.initFormData) && newVal.dataId === this.initFormData.dataId) {
					this.isFormDirty = true;
				}
			},
			deep: true
		}
	},
	methods: {
		initValues() {
			if (this.data.id) return;
			this.dataId = null;
			this.dataName = "";
			this.dataStreet = "";
			this.description = "";

			this.$validator.reset();
		},
		handleCreateOrUpdateSuccess() {
			this.initValues();
			if (this.dataId) {
				this.$emit("closePopup");
			}
			this.isFormDirty = false;
			this.$store.dispatch("deviceManagement/fetchInventories", {
				limit: -1,
				fetchPolicy: "no-cache"
			});
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: this.$t(
						`${
							this.dataId
								? "UpdateInventoryItemSuccessful"
								: "CreateInventoryItemSuccessful"
						}`
					)
				}
			});
		},
		async handleCreateOrUpdateInventory(dataObj) {
			try {
				this.$vs.loading();
				if (this.dataId) {
					await this.$store.dispatch(
						"deviceManagement/updateInventory",
						{
							...dataObj,
							id: this.dataId
						}
					);
				} else {
					await this.$store.dispatch(
						"deviceManagement/addInventory",
						dataObj
					);
				}

				this.handleCreateOrUpdateSuccess();
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		submitData() {
			this.$validator.validateAll().then(result => {
				if (result) {
					const dataObj = {
						name: this.dataName,
						street: this.dataStreet,
						description: this.description
					};
					this.handleCreateOrUpdateInventory(dataObj);
				}
			});
		}
	},
	computed: {
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			}
		},
		computedFormData() {
			return {
				dataId: this.dataId,
				dataName: this.dataName,
				dataStreet: this.dataStreet,
				description: this.description
			};
		}
	}
};
</script>

<style lang="scss" scoped>
::v-deep header {
	&.vs-popup--header {
		h3 {
			text-transform: uppercase;
		}
	}
}

.custom-nested-dialog ::v-deep .el-dialog {
	max-height: 450px;
}
</style>
